import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {SavedMealLineInput} from '../ports/saved-meal.repository';
import {
  SAVED_MEAL_MAX_KCAL,
  SAVED_MEAL_MAX_MACRO_GRAMS,
  SAVED_MEAL_MAX_QUANTITY_GRAMS,
  SAVED_MEAL_NAME_MAX,
} from '../../lib/constants';

export class SavedMealLineDataValidator implements Validator<SavedMealLineInput> {
  readonly standardSchema = z.strictObject({
    displayName: z.string().trim().min(1, 'Name is required.').max(SAVED_MEAL_NAME_MAX),
    quantityGrams: z
      .number({error: 'Grams is required.'})
      .min(0)
      .max(SAVED_MEAL_MAX_QUANTITY_GRAMS),
    kcal: z.number().min(0).max(SAVED_MEAL_MAX_KCAL),
    proteinGrams: z.number().min(0).max(SAVED_MEAL_MAX_MACRO_GRAMS),
    carbsGrams: z.number().min(0).max(SAVED_MEAL_MAX_MACRO_GRAMS),
    fatGrams: z.number().min(0).max(SAVED_MEAL_MAX_MACRO_GRAMS),
  });

  validate(value: unknown): Result<SavedMealLineInput, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid saved meal line.'),
      );
    }
    return ok(parsed.data);
  }
}
